<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="name" >
        <span slot="label" >
          <a-tooltip>
            {{$t('车辆名称')}}<template slot="title">{{$t('车辆名称')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.name" :maxLength="255" :placeholder="$t('请输入')+$t('车辆名称')" />
      </a-form-model-item>
      <a-form-model-item prop="maxVolume" >
        <span slot="label" >
          <a-tooltip>
            最大容积<template slot="title">最大容积 单位 立方米</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.maxVolume" oninput="value=value.replace(/^\D*([0-9]\d*\.?\d{0,3})?.*$/, '$1')"  :placeholder="$t('请输入')+$t('最大容积')" />
        <span class="ant-input-suffix">m³</span>
      </a-form-model-item>
      <a-form-model-item prop="maxWeight" >
        <span slot="label" >
          <a-tooltip>
           最大承重<template slot="title">最大承重 单位kg</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.maxWeight" oninput="value=value.replace(/^\D*([0-9]\d*\.?\d{0,3})?.*$/, '$1')"  :placeholder="$t('请输入')+$t('最大承重')" />
        <span class="ant-input-suffix">kg</span>
      </a-form-model-item>
      <a-form-model-item prop="startPrice" >
        <span slot="label" >
          <a-tooltip>
            {{$t('起步价')}}<template slot="title">{{$t('起步价')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.startPrice" oninput="value=value.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1')"  :placeholder="$t('请输入')+$t('起步价')" />
      </a-form-model-item>
      <a-form-model-item prop="startKm" >
        <span slot="label" >
          <a-tooltip>
            {{$t('起步公里数')}}<template slot="title">{{$t('起步公里数')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.startKm" oninput="value=value.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1')"  :placeholder="$t('请输入')+$t('起步公里数')" />
      </a-form-model-item>
      <a-form-model-item prop="kmPrice" >
        <span slot="label" >
          <a-tooltip>
            {{$t('每公里单价')}}<template slot="title">{{$t('每公里单价')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.kmPrice" oninput="value=value.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1')" :placeholder="$t('请输入')+$t('每公里单价')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('状态')" prop="status" >
        <a-radio-group v-model="form.status" button-style="solid">
          <a-radio-button v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item prop="sort" >
        <span slot="label" >
          <a-tooltip>
            {{$t('排序')}}<template slot="title">{{$t('排序')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.sort"  :placeholder="$t('请输入')+$t('排序')" />
      </a-form-model-item>
      <a-form-model-item prop="remark" >
        <span slot="label" >
          <a-tooltip>
            {{$t('备注')}}<template slot="title">{{$t('备注')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.remark" :placeholder="$t('请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getShippingTemplateVehicle, addShippingTemplateVehicle, updateShippingTemplateVehicle } from '@/api/goods/shippingTemplateVehicle'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,

        name: null,

        maxVolume: null,

        maxWeight: null,

        startPrice: null,

        startKm: null,

        kmPrice: null,

        status: true,

        sort: null,

        createTime: null,

        remark: null,
        localeFieldMap: {},

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        name: [
          { required: true, message: this.$t('车辆名称')+this.$t('不能为空'), trigger: 'blur' }
        ],
        maxVolume: [
          { required: true, message: this.$t('最大容积')+this.$t('不能为空'), trigger: 'blur' }
        ],
        maxWeight: [
          { required: true, message: this.$t('最大承重')+this.$t('不能为空'), trigger: 'blur' }
        ],
        startPrice: [
          { required: true, message: this.$t('起步价')+this.$t('不能为空'), trigger: 'blur' }
        ],
        startKm: [
          { required: true, message: this.$t('起步公里数')+this.$t('不能为空'), trigger: 'blur' }
        ],
        kmPrice: [
          { required: true, message: this.$t('每公里单价')+this.$t('不能为空'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('状态')+this.$t('不能为空'), trigger: 'change' }
        ],
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        name: null,
        maxVolume: null,
        maxWeight: null,
        startPrice: null,
        startKm: null,
        kmPrice: null,
        status: true,
        sort: null,
        createTime: null,
        remark: null,
        localeFieldMap: {},
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getShippingTemplateVehicle({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateShippingTemplateVehicle(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addShippingTemplateVehicle(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
